import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { TextField } from "@material-ui/core";
import { Redirect } from "react-router-dom";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import "react-phone-number-input/style.css";
import { injectIntl } from "react-intl";
import * as auth from "../../store/ducks/auth.duck";
import { activeAccountMarker } from "../../crud/auth.crud";
import { showErrorMessage, showSuccessMessageIcon } from "../../actions/notification";

function ActiveMarker(props) {
	const [isRequested, setRequested] = useState(false);
	const { intl } = props;
	const passRef = React.createRef();
	const rePassRef = React.createRef();
	const tagRef = React.createRef();
	const firstNameRef = React.createRef();
	const lastNameRef = React.createRef();
	const companyRef = React.createRef();
	const mobileRef = React.createRef();
	const [dataAdd, setData] = useState({});
	const [styleLine, setStyleLine] = useState(false);
	const [dataError, setError] = useState({
		first_name: false,
		tag: false,
		company: false,
		mobile: false,
		password: false,
		rePassword: false,
	})
	if (isRequested) {
		return <Redirect to="/auth" />;
	}

	const onChangeMobile = (mobile) => {
		if (mobile === undefined) mobile = "";
		setData({
			...dataAdd,
			mobile,
		});
	};
	return (
		<div
			className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper"
			style={{ paddingTop: 185 }}
		>
			<div className="kt-login__body">
				<div className="kt-login__form">
					<div className="kt-login__title">
						<h3>Complete Your Profile</h3>
					</div>

					<Formik
						initialValues={{ first_name: "", last_name: "", company: "", mobile: "", password: "", rePassword: "" }}
						onSubmit={(values, { setStatus, setSubmitting }) => {
							if (!values.first_name || (values.first_name && !values.first_name.trim())) {
								setSubmitting(false);
								firstNameRef.current.focus();
								setError({ ...dataError, first_name: true });
								return showErrorMessage("Please enter first name.");
							} else {
								if (values.first_name.length > 50) {
									setSubmitting(false);
									firstNameRef.current.focus();
									setError({ ...dataError, first_name: true });
									return showErrorMessage("First name must be longer than 50 characters.");
								}
							}
							if (!values.last_name || (values.last_name && !values.last_name.trim())) {
								setSubmitting(false);
								lastNameRef.current.focus();
								setError({ ...dataError, first_name: false, last_name: true });
								return showErrorMessage("Please enter last name.");
							} else {
								if (values.last_name.length > 50) {
									setSubmitting(false);
									lastNameRef.current.focus();
									setError({ ...dataError, first_name: false, last_name: true });
									return showErrorMessage("Last name must be longer than 50 characters.");
								}
							}
							if (!values.tag || (values.tag && !values.tag.trim())) {
								setSubmitting(false);
								tagRef.current.focus();
								setError({ ...dataError, first_name: false, last_name: false, tag: true });
								return showErrorMessage("Please enter tag name.");
							} else {
								if (values.tag.length > 4) {
									setSubmitting(false);
									tagRef.current.focus();
									setError({ ...dataError, first_name: false, last_name: false, tag: true });
									return showErrorMessage("Tag may not be greater than 4 characters.");
								}
							}
							if (!values.company || (values.company && !values.company.trim())) {
								setSubmitting(false);
								companyRef.current.focus();
								setError({ ...dataError, first_name: false, last_name: false, tag: false, company: true });
								return showErrorMessage("Please enter company name.");
							} else {
								if (values.company.length > 100) {
									setSubmitting(false);
									companyRef.current.focus();
									setError({ ...dataError, first_name: false, last_name: false, tag: false, company: true });
									return showErrorMessage("Company name may not be greater than 100 characters.");
								}
							}
							if (dataAdd.mobile) {
								setSubmitting(false);
								let valid = dataAdd.mobile && isValidPhoneNumber(dataAdd.mobile) ? "true" : "false";
								if (valid === "false") {
									setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: true });
									return showErrorMessage("Please enter a valid phone number.");
								}
							} else {
								setSubmitting(false);
								if (mobileRef.current) {
									mobileRef.current.focus()
								}
								setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: true });
								return showErrorMessage("Please enter phone number.");
							}
							if (!values.password) {
								setSubmitting(false);
								passRef.current.focus();
								setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: false, password: true });
								return showErrorMessage("Please enter password.");
							} else {
								if (values.password.length < 6) {
									setSubmitting(false);
									passRef.current.focus();
									setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: false, password: true });
									return showErrorMessage("Password must be at least 6 characters.");
								}
								if (values.password.length > 20) {
									setSubmitting(false);
									passRef.current.focus();
									setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: false, password: true });
									return showErrorMessage("Password must be longer than 20 characters.");
								}
								const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{6,}$/;
								if (!regex.test(values.password)) {
									setSubmitting(false);
									passRef.current.focus();
									setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: false, password: true });
									return showErrorMessage(
										"Password contains at least a upper case, lower case, symbol and a number. Except space character"
									);
								}
							}
							if (!values.rePassword) {
								setSubmitting(false);
								rePassRef.current.focus();
								setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: false, password: false, rePassword: true });
								return showErrorMessage("Please confirm password.");
							}

							if (values.password !== values.rePassword) {
								setSubmitting(false);
								passRef.current.focus();
								setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: false, password: false, rePassword: true });
								return showErrorMessage("Invalid. Password and re-password do not match.");
							}
							setError({ ...dataError, first_name: false, last_name: false, tag: false, company: false, mobile: false, password: false, rePassword: false });
							// let email = props.match.params.email;
							let strConfirm = props.match.params.strConfirm;

							activeAccountMarker({
								...values,
								strConfirm,
								first_name: values.first_name.trim(),
								last_name: values.last_name.trim(),
								company: values.company.trim(),
							})
								.then(({ data }) => {
									if (data.signal) {
										showSuccessMessageIcon("Update success.");
										props.login(data?.data);
									} else {
										setRequested(false);
										return showErrorMessage("Opps! Something was wrong!");
									}
								})
								.catch(() => {
									setSubmitting(false);
									setStatus(intl.formatMessage({ id: "AUTH.VALIDATION.NOT_FOUND" }, { name: values.password }));
								});
						}}
					>
						{({ values, status, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
							<form onSubmit={handleSubmit} className="kt-form">
								{status && (
									<div role="alert" className="alert alert-danger">
										<div className="alert-text">{status}</div>
									</div>
								)}
								<div className="form-group" style={{ display: "flex" }}>
									<TextField
										style={{ marginRight: 5 }}
										type="text"
										label="First Name"
										margin="normal"
										fullWidth={true}
										name="first_name"
										onBlur={handleBlur}
										onChange={handleChange}
										value={values.first_name}
										autoFocus
										inputRef={firstNameRef}
										error={dataError.first_name}
									/>

									<TextField
										style={{ marginLeft: 5 }}
										type="text"
										label="Last Name"
										margin="normal"
										fullWidth={true}
										name="last_name"
										onBlur={handleBlur}
										onChange={handleChange}
										value={values.last_name}
										inputRef={lastNameRef}
										error={dataError.last_name}
									/>
								</div>

								<div className="form-group" style={{ display: "flex" }}>
									<TextField
										style={{ marginRight: 5 }}
										type="text"
										label="Tag"
										margin="normal"
										fullWidth={true}
										name="tag"
										onBlur={handleBlur}
										onChange={handleChange}
										value={values.tag}
										inputRef={tagRef}
										helperText={
											<p
												style={{
													fontSize: "8pt",
													marginBottom: 0,
													fontStyle: "italic",
												}}
											>
												This tag will be use for the course certification combination
											</p>
										}
										error={dataError.tag}
									/>
								</div>
								<div className="form-group" style={{ display: "flex" }}>
									<TextField
										style={{ marginRight: 5 }}
										type="text"
										label="Company"
										margin="normal"
										fullWidth={true}
										name="company"
										onBlur={handleBlur}
										onChange={handleChange}
										value={values.company}
										inputRef={companyRef}
										error={dataError.company}
									/>
									<div style={{ width: "50%" }}>
										{styleLine && (
											<label
												style={{
													fontSize: 9,
													color: styleLine ? "#5867dd" : "rgba(0, 0, 0, 0.54)",
													paddingLeft: 7,
													fontWeight: 400,
													lineHeight: 1,
													letterSpacing: "0.00938em",
												}}
											>
												Phone number
											</label>
										)}
										<PhoneInput
											style={{
												marginLeft: 5,
												display: "flex",
												borderRadius: "unset",
												borderBottom: styleLine ? "2px solid #5867dd" : "1px solid #949494",
												height: 44,
												marginTop: styleLine ? -5 : "",
												background: "#fff",
											}}
											international
											countryCallingCodeEditable={false}
											className={(dataAdd.mobile ? (isValidPhoneNumber(dataAdd.mobile) ? undefined : true) : dataError.mobile) ? 'form-control has-error' : 'form-control'}
											flags={flags}
											placeholder="Enter phone number"
											defaultCountry="SG"
											value={dataAdd.mobile}
											onChange={onChangeMobile}
											ref={mobileRef}
											error={
												dataAdd.mobile ? (isValidPhoneNumber(dataAdd.mobile) ? undefined : "Invalid phone number") : ""
											}
											onFocus={() => {
												setStyleLine(true);
											}}
											onBlur={() => {
												setStyleLine(false);
											}}
										/>
									</div>
								</div>
								<div className="form-group" style={{ display: "flex" }}>
									<TextField
										style={{ marginRight: 5 }}
										type="password"
										label="Password"
										margin="normal"
										fullWidth={true}
										name="password"
										onBlur={handleBlur}
										onChange={handleChange}
										value={values.password}
										inputRef={passRef}
										error={dataError.password}
									/>
									<TextField
										style={{ marginLeft: 5 }}
										type="password"
										label="Re-password"
										margin="normal"
										fullWidth={true}
										name="rePassword"
										onBlur={handleBlur}
										onChange={handleChange}
										value={values.rePassword}
										inputRef={rePassRef}
										error={dataError.rePassword}
									/>
								</div>

								<div className="form-group"></div>

								<div className="kt-login__actions" style={{ justifyContent: "center" }}>
									{/* <Link to="/auth">
										<button type="button" className="btn btn-secondary btn-elevate kt-login__btn-secondary">
											Back
										</button>
									</Link> */}

									<button
										type="submit"
										className="btn btn-primary btn-elevate kt-login__btn-primary"
										disabled={isSubmitting}
									>
										Submit
									</button>
								</div>
							</form>
						)}
					</Formik>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(connect(null, auth.actions)(ActiveMarker));
